/* istanbul ignore file */
import { array as codecArray } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { RubricAnalyticsDataRow } from './RubricAnalyticsDataRow';
const RubricAnalyticsDataParser = /* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('rubric')],
    ['rows', /* #__PURE__ */ codecArray(RubricAnalyticsDataRow)],
]);
export class RubricAnalyticsData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RubricAnalyticsDataParser.decode(input).map(res => new RubricAnalyticsData(res));
    }
    static unsafeDecode(input) {
        return RubricAnalyticsData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RubricAnalyticsDataParser.encode(data);
    }
    static schema() {
        return RubricAnalyticsDataParser.schema();
    }
}
